// ============================================================
// Audit Log Page
// ============================================================

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Shield } from 'lucide-react';

export function AuditLogPage() {
    const { data, isLoading } = useQuery({
        queryKey: ['audit-logs'],
        queryFn: () => api.get('/audit-logs'),
    });

    const logs = data?.data || [];

    return (
        <div className="animate-fadeIn">
            <div className="page-header">
                <div>
                    <h1>Audit Logs</h1>
                    <p className="subtitle">Track all actions performed in your workspace</p>
                </div>
            </div>

            <div className="card">
                {logs.length === 0 ? (
                    <div className="empty-state">
                        <Shield size={40} style={{ opacity: 0.3 }} />
                        <h3 className="mt-4">No audit logs yet</h3>
                        <p>Actions will be recorded as your team uses the platform</p>
                    </div>
                ) : (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>User</th>
                                <th>Entity</th>
                                <th>IP Address</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log: any) => (
                                <tr key={log.id}>
                                    <td>
                                        <span className="badge badge-accent">{log.action}</span>
                                    </td>
                                    <td>
                                        <div style={{ fontWeight: 500 }}>{log.user?.name || '—'}</div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>{log.user?.email}</div>
                                    </td>
                                    <td style={{ color: '#4b5563', fontSize: '13px' }}>
                                        {log.entityType ? `${log.entityType}/${log.entityId?.substring(0, 8)}...` : '—'}
                                    </td>
                                    <td style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'monospace' }}>
                                        {log.ipAddress || '—'}
                                    </td>
                                    <td style={{ color: '#6b7280', fontSize: '13px' }}>
                                        {new Date(log.createdAt).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
